import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ServicePackagePurchase } from '@beautyapp/core';
import { TranslateService } from '@ngx-translate/core';
import { PackageCancelModalComponent } from './package-cancel-modal.component';

/**
 * Opens the cancellation modal for an unused package sold on an earlier day
 * (beaut-484). Closes with `true` once cancelled; callers reload on a truthy
 * `afterClose`.
 */
export function openPackageCancelModal(
  modalService: NzModalService,
  translate: TranslateService,
  purchase: ServicePackagePurchase
): NzModalRef<PackageCancelModalComponent, boolean> {
  return modalService.create<
    PackageCancelModalComponent,
    { purchase: ServicePackagePurchase },
    boolean
  >({
    nzTitle: translate.instant('servicePackages.confirm.cancel'),
    nzContent: PackageCancelModalComponent,
    nzData: { purchase },
    nzWidth: 520,
    nzFooter: null,
  });
}
